import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qrt978zrg: FaireProductEntity = {
  token: "p_6qrt978zrg",
  type: "product",
  name: "Liposomal Glutathione",
  brandToken: "b_9lnqwiw9kl",
  brandName: "Cymbiotika",
  imageUrl:
    "https://cdn.faire.com/fastly/b4cc7e4b6e06b91ceb9183170a74ea7a3669173558706933cc911c1283f47304.png",
  galleryImageUrls: [],
  priceDollars: 48.4,
  description:
    "Support your body’s natural defenses with this advanced liposomal glutathione formula. Glutathione is often called the body’s “master antioxidant,” playing a vital role in detoxification, immune health, and protecting cells from oxidative stress. This formula uses a liposomal delivery system, which helps protect glutathione through digestion and improves absorption, making it more effective than standard supplements.\n\nAlongside glutathione, this formula also features PQQ, a powerful antioxidant compound that helps reduce oxidative stress and supports brain and mitochondrial health. With just the right amount of vitamin B2 to meet daily needs, this formula avoids excess dosing, offering practical, targeted support you can trust. Clean, convenient, and thoughtfully formulated to help you stay resilient and energized.",
  tags: [],
  msrpDollars: 87.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:29.653Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
